import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useMemo } from 'react';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import ExpandCollapseCell from './ExpandCollapseCell';

const ActualizedAmountColumnDetailHeaderCell = (props: GridHeaderCellProps) => {
  const { actualizedAmountData, setActualizedAmountData } = useViewCheckbook();

  const isAllExpanded = useMemo(
    () => actualizedAmountData.some((transaction) => transaction.expanded),
    [actualizedAmountData]
  );

  const handleHeaderCellExpand = () => {
    setActualizedAmountData((prev) =>
      [...prev].map((item) => ({ ...item, expanded: !isAllExpanded }))
    );
  };

  return (
    <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <ExpandCollapseCell
        expand={isAllExpanded}
        onExpand={handleHeaderCellExpand}
        title="Expand/Collapse All"
      />
    </th>
  );
};

export default ActualizedAmountColumnDetailHeaderCell;
